import React from 'react'
import axios from 'axios'
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col, Alert, CustomInput } from 'reactstrap'
import { connect } from 'react-redux'
// import MyEditor from './Draft.js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import MyEditorSynthesis from './Draft_Synthesis'

import 'react-datepicker/dist/react-datepicker.css'

import brand from '../images/brand.png'

function getIDs (x) {
  let result = []
  for (let i = 0; i < x.length; i++) {
    result.push(x[i]._id)
  }
  return result
}

function tradError (x) {
  let code = x.state.resCode
  if (code === 201) { return 'Votre article a été modifié avec succés!' }
  if (code === 409) { return 'Ce titre est déjà utilisé.' }
  if (code === 503) { return 'Erreur' }
  if (code === 400) { return 'Verifiez bien que tous les champs on bien été remplis...'}
}

class ModifyContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editorState: null,
      article: null,
      code: null,
      categories: null,
      imgPrev: '',
      imgCount: 0,
      checkedCateg: [],
      resCode: 0,
      toggleMsg: false,
      resMsg: '',
      dateSelect: moment()
    }
    this.handleText = this.handleText.bind(this)
    this.handleImage = this.handleImage.bind(this)
    this.handleCategories = this.handleCategories.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onEditorStateChange = this.onEditorStateChange.bind(this)
  }

  componentWillMount () {
    this.setState({
      ...this.state,
      categories: this.props.categories
    })
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/content/${this.props.articleID}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then((res) => {
      this.setState({
        ...this.state,
        typeContent: res.data.type.toLowerCase(),
        editorState: EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.data.content))),
        article: {
          ...res.data,
          categories: getIDs(res.data.categories),
          author_id: res.data.author_id._id,
          end_of_participation_date: new Date(res.data.end_of_participation_date)
        },
        code: res.request.status,
        dateSelect: moment(res.data.end_of_participation_date)
      })
    }).catch((err) => {
      throw err
    })
  }

  handleText (e) {
    this.setState({
      ...this.state,
      article: {
        ...this.state.article,
        [e.target.name]: e.target.value
      }
    })
  }

  onEditorStateChange (editorState) {
    this.setState({
      ...this.state,
      editorState,
      article: {
        ...this.state.article,
        content: draftToHtml(convertToRaw(editorState.getCurrentContent()))
      }
    })
  }

  handleImage(e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]
    let count = this.state.imgCount + 1
    reader.onload = () => {
      this.setState({
        ...this.state,
        imgPrev: reader.result,
        imgCount: count,
        article: {
          ...this.state.article,
          image: file
        }
      })
    }
    reader.readAsDataURL(file)
  }

  handleCategories (e) {
    if (e.target.checked) {
      let cat = this.state.article.categories.concat(e.target.id)
      this.setState({
        ...this.state,
        article: {
          ...this.state.article,
          categories: cat
        }
      })
    } else {
      let categ = this.state.article.categories
      let index = categ.indexOf(e.target.id)
      if (index > -1) {
        categ.splice(index, 1)
        this.setState({
          ...this.state,
          article: {
            ...this.state.article,
            categories: categ
          }
        })
      }
    }
  }

  handleDate (date) {
    this.setState({
      ...this.state,
      dateSelect: date,
      article: {
        ...this.state.article,
        end_of_participation_date: new Date(date)
      }
    })
  }

  handleSubmit () {
    const formData = new FormData()
    let article = this.state.article
    article.synthesis = this.props.synthesis
    console.log(article)
    for (let key in article) {
      formData.append(key, article[key])
      console.log(key, article[key])
    }
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_URL}/content/${this.state.typeContent}/${this.state.article._id}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then((res) => {
      this.setState({
        ...this.state,
        resCode: res.status
      })
    }).catch((res) => {
    })
    this.setState({
      ...this.state,
      toggleMsg: true
    })
  }

  render () {
    // const DATE = this.state.article.end_of_participation_date !== undefined ? 'La date limite de participation au challenge sera le ' + this.state.challenge.endDate.toLocaleDateString() : ''
    console.log(this.props)
    if (this.state.code !== 200) {
      return <div className={'w100p h90vh vCenter'}><div className={'w50p'}><img className={'imgResponsive'} src={brand} alt='loading imge' /></div></div>
    } else {
      let itit = this.state.categories.filter(cat => cat.type === 'BOARD')
      let time = this.state.categories.filter(cat => cat.type === 'TIME')
      let global = this.state.categories.filter(cat => cat.type === 'GLOBAL')
      console.log(this.state);
      return (
        (this.state.code !== 200) ? <div className={'w100p h90vh vCenter'}><div className={'w50p'}><img className={'imgResponsive'} src={brand} alt='chargement' /></div></div> :
          <div>
            <Container className={'mT-5 mB-5'}>
              <Row>
                <Col>
                  <h1 className={'txtcenter'}>Modifier mon article</h1>
                </Col>
              </Row>
              <Form>
                <Row>
                  <Col md={{ size: 6, offset: 3 }}>
                    <FormGroup>
                      <Label for='exampleText'>Titre</Label>
                      <Input type='text' name='title' value={this.state.article.title} id='title' onChange={this.handleText.bind(this)}/>
                    </FormGroup>
                    <FormGroup>
                      <Label for='exampleText'>Description Courte</Label>
                      <Input type='textarea' value={this.state.article.description} name='description' id='shortDescription' onChange={this.handleText.bind(this)}/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className={''} md={{size: 6, offset: 3}}>
                    <Label for="exampleFile">Image</Label>
                    <Input type="file" name="file" onChange={this.handleImage.bind(this)}/>
                    <FormText color="muted">
                      { 'Taille maximale: 5mb+' }
                    </FormText>
                    <div className={'border-grey p-2 brad-5 txtcenter '}>
                      <img className={'ofit-cover h100p w100p'} src={ this.state.imgCount >= 1 ? this.state.imgPrev : `${process.env.REACT_APP_API_URL}/${this.state.article.image}` } alt='preview'/>
                    </div>
                  </Col>
                </Row>

                {/* CATEGORIES */}
                <Row>
                  <Col>
                    <h3>Catégories:</h3>
                  </Col>
                </Row>
                <hr />
                <Row className={''}>
                  <Col className={''}>
                    <FormGroup className={'hCenter'}>
                      <Label className={'font-b marker'} for='exampleCheckbox'>ITITOCA Board</Label>
                      <div>
                        {itit.map(cat => {
                          let checkedCat = this.state.article.categories
                          return (<CustomInput name={cat.name} defaultChecked={checkedCat.indexOf(cat._id) >= 0 ? true : false } type='checkbox' id={cat._id}  key={cat._id} value={cat.name} inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>
                          )
                        })
                        }
                      </div>
                    </FormGroup>
                  </Col>
                  <Col className={'vCenter'}>
                    <FormGroup>
                      <Label className={'font-b marker'} for='exampleCheckbox'>Temps</Label>
                      <div>
                        {time.map(cat => {
                          let checkedCat = this.state.article.categories
                          return (<CustomInput name={cat.name} defaultChecked={checkedCat.indexOf(cat._id) >= 0 ? true : false } type='checkbox' id={cat._id} key={cat._id} value='10mins' inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)})}
                      </div>
                    </FormGroup>
                  </Col>
                  <Col className={'vCenter'}>
                    <FormGroup>
                      <Label className={'font-b marker'} for='exampleCheckbox'>Cible</Label>
                      <div>
                        {global.map(cat => {
                          let checkedCat = this.state.article.categories
                          return (<CustomInput name={cat.name} defaultChecked={checkedCat.indexOf(cat._id) >= 0 ? true : false } type='checkbox' id={cat._id} key={cat._id} value='Moi' inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>
                          )
                        })
                        }
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <hr />

                {/* TEXT EDITOR */}
                <Row>
                  <Col>
                    <div className={'border-grey'}>
                      <Editor toolbarClassName={'bg-ititoca'} editorState={this.state.editorState} onEditorStateChange={this.onEditorStateChange.bind(this)}/>
                    </div>
                  </Col>
                </Row>
                {
                  this.state.article.type === 'CHALLENGE' &&
                  <div className={'mT-10'}>
                    <h2 className='text-center '>Modifier la synthèse du challenge</h2>
                    <MyEditorSynthesis value={this.state.article.synthesis}/>
                    <FormGroup>
                      <h2 className={'font-b text-center mT-10'}  for='exampleText'>Modifier le code embed<span className={'color-red'}>*</span></h2>
                      <Input type='url' value={this.state.article.embedded} placeholder='<iframe ... >...</iframe>' name='embedded' id='embedded' onChange={this.handleText.bind(this)} />
                      <p className={'txtcenter pT-2'}>Exemple:</p>
                      <ul>
                        <li>Texte:  <span className={'color-green'}>{'  <p>Votre texte ici</p>'}</span></li>
                        <li>Vidéo (Youtube ou Vimeo): <span className={'color-green'}>{'<iframe...>...</iframe...>'}</span></li>
                        <li>Image: <span className={'color-green'}>{'<img src=\'monURL\' alt=\'monTitre\'>'}</span></li>
                      </ul>
                    </FormGroup>
                  </div>
                }
              </Form>
              <hr />
              <Row>
                <Col>
                  <Button className={'p-3'} color='success' onClick={this.handleSubmit.bind(this)}>SAUVEGARDER</Button>
                </Col>
                <Col>
                  {this.state.toggleMsg === true ? <Alert className={'txtcenter'} color={this.state.resCode === 201 ? 'success' : 'danger'}><i className={this.state.resCode === 201 ? "check icon" : "exclamation circle icon"} />{tradError(this)}</Alert> : null }
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 6, offset: 3 }} className={''}>
                  <Label>Date Limite: <span className={'color-red'}>*</span></Label>
                  <Col className={'txtcenter'}>
                    <DatePicker format='DD-MM-YYYY' inline selected={this.state.dateSelect} onChange={this.handleDate.bind(this)} locale='fr' />
                  </Col>
                </Col>
              </Row>
              <Row className={''}>
                <Col sm={{ size: 6, offset: 3 }} className={'vCenter txtcenter roboto grey-ititoca mR-15'}>
                  <h4>La date limite de participation au challenge sera le : {this.state.article.end_of_participation_date && this.state.article.end_of_participation_date.toLocaleDateString()}</h4>
                </Col>
              </Row>
            </Container>
          </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    articleID: state.data.article_id,
    categories: state.data.categories,
    synthesis: state.synthesis.htmlSynthesis
  }
}

function mapDispatchToProps (dispatch) {
}

export default connect(mapStateToProps, null)(ModifyContent)

export { ModifyContent }



// WEBPACK FOOTER //
// ./src/components/ModifyContent.js